<template>
  <div>
    <el-form ref="searchform" :model="searchform" label-width="75px">
      <el-row>
        <el-col :span="6">
          <el-form-item label="工厂" prop="factoryCode">
            <el-select
              type="text"
              filterable
              v-model="searchform.factoryCode"
              @change="getworkshoplistsearch(searchform.factoryCode)"
              style="width:100%"
            >
              <el-option
                v-for="(item,index) in factorylist"
                :key="index"
                :label="item.factory_name"
                :value="item.factory_code"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="车间" prop="workshopCode">
            <el-select
              type="text"
              filterable
              v-model="searchform.workshopCode"
              @change="getworklinelistlistsearch(searchform.workshopCode)"
              style="width:100%"
            >
              <el-option
                v-for="(item,index) in workshoplist"
                :key="(item,index)"
                :label="item.workshop_name"
                :value="item.workshop_code"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="产线" prop="worklineCode">
            <el-select type="text" filterable v-model="searchform.worklineCode" style="width:100%">
              <el-option
                v-for="(item,index) in worklinelist"
                :key="index"
                :label="item.workline_name"
                :value="item.workline_code"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="产品" prop="productCode">
            <el-input v-model.trim="searchform.productCode" style="width:100%" clearable></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="生产日期"  prop="datelist">
            <el-date-picker
              style="width:100%"
              v-model="searchform.datelist"
              type="daterange"
              value-format="timestamp"
              range-separator="-"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              :default-time="['00:00:00', '23:59:59']"
            ></el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="5" :offset="1">
          <el-button @click="resetForm('searchform')">重置</el-button>
          <el-button type="primary" @click="getproductioncount()" icon="el-icon-search"></el-button>
        </el-col>
      </el-row>
    </el-form>
    <line-chartb :chart-data="lineChartData" />
  </div>
</template>

<script>
import LineChartb from "../LineChartb";
import { productioncount } from "@/api/report";
import { productTree } from "@/api/base";
import { factorylist, worklinelist, workshoplist } from "@/api/plant";
export default {
  components: {
    LineChartb
  },
  data() {
    return {
      lineChartData: {
        expectedData:[],
        actualData:[],
        chartdatelist:[],
      },
      codearr: null,
      // 扫码查询参数
      searchform: {
        productCode: null,
        datelist: null,
        factoryCode: null,
        workshopCode: "",
        worklineCode: ""
      },
      factorylist: [],
      workshoplist: [],
      worklinelist: [],
    };
  },
  methods: {
    // 车间下拉
    getworkshoplistsearch(value) {
      this.searchform.workshopCode = "";
      this.searchform.worklineCode = "";
      this.codearr = value.split("|"); // 把工厂下拉gey 对应工厂编码跟子编码拆开存数组
      workshoplist({
        factory_code: this.codearr[0] || null,
        factory_sub_code: this.codearr[1] || null,
        workorder_status: 0,
        pageSize: 1000
      }).then(response => {
        // 车间下拉
        this.workshoplist = response.data.data;
        for (let i = 0; i < this.workshoplist.length; i++) {
          this.workshoplist[i].workshop_name =
            this.workshoplist[i].workshop_code +
            "|" +
            this.workshoplist[i].workshop_name;
        }
      });
    },
    getworklinelistlistsearch(value) {
      this.searchform.worklineCode = "";
      this.worklinelist = [];      // 产线下拉
      worklinelist({factory_code: this.codearr[0] || null,
        factory_sub_code: this.codearr[1] || null, workshop_code: value, workorder_status: 0 }).then(
        response => {
          this.worklinelist = response.data.data;
          for (let b = 0; b < this.worklinelist.length; b++) {
            this.worklinelist[b].workline_name =
              this.worklinelist[b].workline_code +
              "|" +
              this.worklinelist[b].workline_name;
          }
        }
      );
    },
    //重置按钮
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    //
    // 扫码查询次数
    getproductioncount() {
      productioncount({
        productCode: this.searchform.productCode,
        datelist: this.searchform.datelist,
        factoryCode: this.searchform.factoryCode,
        workshopCode: this.searchform.workshopCode,
        worklineCode: this.searchform.worklineCode,
        time1:
          this.searchform.datelist == null ? null : this.searchform.datelist[0],
        time2:
          this.searchform.datelist == null ? null : this.searchform.datelist[1]
      }).then(response => {
        this.lineChartData.actualData = [];
        this.lineChartData.expectedData = [];
        this.lineChartData.chartdatelist = [];
        for (let i = 0; i < response.data.length; i++) {
          this.lineChartData.actualData.push(response.data[i].qrcodeqty1);
          this.lineChartData.expectedData.push(response.data[i].qrcodeqty2);
          response.data[i].createDate = response.data[i].createDate.substring(0, response.data[i].createDate.length - 8);
          this.lineChartData.chartdatelist.push(response.data[i].createDate);
        }
      });
    }
  },
  mounted() {
    // 图表初始数据调用
    this.getproductioncount();
    //下拉
    factorylist({ pageSize: 10000 }).then(response => {
      this.factorylist = response.data.data;
      for (let c = 0; c < this.factorylist.length; c++) {
        this.factorylist[c].factory_name =
          this.factorylist[c].factory_code +
          "|" +
          this.factorylist[c].factory_sub_code +
          "|" +
          this.factorylist[c].factory_name;
        this.factorylist[c].factory_code =
          this.factorylist[c].factory_code +
          "|" +
          this.factorylist[c].factory_sub_code;
      }
    });
  }
};
</script>
<style lang="scss" scoped>
.dashboard-editor-container {
  padding: 32px;
  background-color: rgb(240, 242, 245);
  position: relative;

  .github-corner {
    position: absolute;
    top: 0px;
    border: 0;
    right: 0;
  }

  .chart-wrapper {
    background: #fff;
    padding: 16px 16px 0;
    margin-bottom: 32px;
  }
}
</style>
